<mat-form-field appearance="outline">
  <mat-label id="genericListSelect-select-{{ testingId | camelCase }}">{{ value }}</mat-label>
  <mat-select [value]="value" (selectionChange)="handleSelect($event)">
    <mat-option
      id="genericListSelect-option-{{ testingId | camelCase }}-{{ choice | camelCase }}"
      *ngFor="let choice of choices"
      [value]="choice"
    >
      {{ choice }}
    </mat-option>
  </mat-select>
</mat-form-field>
